import { LinearProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { StaticDateRangeSelect } from '@/components/common/date/StaticDateRangeSelect';

import type { RefuelDateSelectView } from '../../utils/refuelDateSelectView';
import { RefuelsErrorState } from '../refuels-error-state/RefuelsErrorState';
import { RefuelsNoResult } from '../refuels-no-result/RefuelsNoResult';

type RefuelDateSelectProps = {
  view: RefuelDateSelectView;
  isFetching: boolean;
  onDatesSelect: (from: Date, to: Date) => void;
  onRetry: () => void;
  onChooseNewDate: () => void;
  onChooseNewVehicle: () => void;
};

function renderView({
  view,
  isFetching,
  onDatesSelect,
  onRetry,
  onChooseNewDate,
  onChooseNewVehicle,
}: RefuelDateSelectProps) {
  switch (view) {
    case 'error':
      return <RefuelsErrorState isRetrying={isFetching} onRetry={onRetry} />;
    case 'noResult':
      return <RefuelsNoResult onChooseNewDate={onChooseNewDate} onChooseNewVehicle={onChooseNewVehicle} />;
    case 'dateRangePicker':
      return <StaticDateRangeSelect setSelectedDates={onDatesSelect} />;
    default:
      return view satisfies never;
  }
}

export function RefuelDateSelect({
  view,
  isFetching,
  onDatesSelect,
  onRetry,
  onChooseNewDate,
  onChooseNewVehicle,
}: RefuelDateSelectProps) {
  const { t } = useTranslation();

  return (
    <>
      {isFetching && <LinearProgress aria-label={t('general.loading')} />}
      {renderView({ view, isFetching, onDatesSelect, onRetry, onChooseNewDate, onChooseNewVehicle })}
    </>
  );
}
